<template>
  <a-flex gap="large" vertical>
    <a-typography-text strong class="editor-title">
      {{ "Редактор контента" }}
    </a-typography-text>

    <a-flex gap="large">
      <LabelTemplateEditObjectMain :loading="loading" />

      <LabelTemplateEditObjectFields :loading="loading" />
    </a-flex>
  </a-flex>
</template>

<script setup lang="ts">
import LabelTemplateEditObjectMain from "@/components/settings/labels/labelTemplateEdit/labelTemplateEditObject/labelTemplateEditObjectMain/LabelTemplateEditObjectMain.vue";
import LabelTemplateEditObjectFields from "@/components/settings/labels/labelTemplateEdit/labelTemplateEditObject/labelTemplateEditObjectFields/LabelTemplateEditObjectFields.vue";

defineProps<{ loading: boolean }>();
</script>

<style scoped lang="scss">
.editor-title {
  padding: 8px 16px;
  background: var(--color-border);
  border-radius: 10px;
  width: fit-content;
}
</style>
